module.exports = __webpack_public_path__ + "img/service_images_bg_01.5aa2b872.png";